module.exports = __webpack_public_path__ + "img/app_store_black.2928664f.svg";